var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71035 5.28013C7.54771 5.12081 7.28563 5.12081 7.12299 5.28013C6.95891 5.44086 6.95891 5.70199 7.12299 5.86272L9.90635 8.58929H1.29167C1.06378 8.58929 0.875 8.77055 0.875 9C0.875 9.22945 1.06378 9.41072 1.29167 9.41072H9.90635L7.12299 12.1373C6.95891 12.298 6.95891 12.5591 7.12299 12.7199C7.20437 12.7996 7.31093 12.8393 7.41667 12.8393C7.5224 12.8393 7.62896 12.7996 7.71035 12.7199L11.2096 9.29205C11.2097 9.29197 11.2097 9.29188 11.2098 9.2918C11.2495 9.25328 11.28 9.20748 11.301 9.15787L11.301 9.1578C11.3436 9.05691 11.3436 8.94332 11.3011 8.84237L11.301 8.84213C11.2797 8.79189 11.2489 8.74657 11.2105 8.70861L11.2101 8.70813L7.71035 5.28013ZM7.71035 5.28013L7.62288 5.36943M7.71035 5.28013L7.71034 5.28013L7.62288 5.36943M7.62288 5.36943C7.50883 5.25771 7.3245 5.25771 7.21046 5.36943C7.09642 5.48114 7.09642 5.66171 7.21046 5.77343L10.085 8.58929L7.62288 5.36943ZM10.034 8.71429H1.29167C1.13037 8.71429 1 8.842 1 9C1 9.158 1.13037 9.28572 1.29167 9.28572H10.034V8.71429ZM14.7083 0.875H3.91667C3.68878 0.875 3.5 1.05626 3.5 1.28571V6.28571C3.5 6.51517 3.68878 6.69643 3.91667 6.69643C4.14455 6.69643 4.33333 6.51517 4.33333 6.28571V1.69643H14.2917V16.3036H4.33333V11.7143C4.33333 11.4848 4.14455 11.3036 3.91667 11.3036C3.68878 11.3036 3.5 11.4848 3.5 11.7143V16.7143C3.5 16.9437 3.68878 17.125 3.91667 17.125H14.7083C14.9362 17.125 15.125 16.9437 15.125 16.7143V1.28571C15.125 1.05626 14.9362 0.875 14.7083 0.875Z",
    fill: "#F8BF2F",
    stroke: "#F8BF2F",
    strokeWidth: 0.25
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutIcon);
export default __webpack_public_path__ + "static/media/log-out-icon.5c2c5152.svg";
export { ForwardRef as ReactComponent };